import React, { useMemo } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from '../../../../../_metronic/_partials/controls';
import { injectIntl } from 'react-intl';
import StocksFilter from './stocks-filter/StocksFilter';
import StocksTable from './stocks-table/StocksTable';
import { useStocksUIContext } from './StocksUIContext';

const StocksCard = (props) => {
  const { intl } = props;
  const title = intl.formatMessage({ id: 'STOCK.TITLE.LIST' });
  const stocksUIContext = useStocksUIContext();
  const stocksUIProps = useMemo(() => {
    return {
      queryParams: stocksUIContext.queryParams,
      setQueryParams: stocksUIContext.setQueryParams,
      openViewStockDialog: stocksUIContext.openViewStockDialog,
      openCreateStockDialog: stocksUIContext.openCreateStockDialog,
      openDeleteStocksDialog: stocksUIContext.openDeleteStocksDialog,
    };
  }, [stocksUIContext]);

  return (
    <Card>
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            className='btn btn-primary'
            onClick={stocksUIProps.openCreateStockDialog}
          >
            Бараа бүртгэх
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <StocksFilter props />
        <StocksTable props />
      </CardBody>
    </Card>
  );
};

export default injectIntl(StocksCard);
